import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=649bf8b2&"
import script from "./connections.vue?vue&type=script&lang=js&"
export * from "./connections.vue?vue&type=script&lang=js&"
import style0 from "./connections.vue?vue&type=style&index=0&id=649bf8b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QBtn,QTooltip,QTable,QTd,QPagination,QDialog,QCard,QCardSection,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon,QBtn,QTooltip,QTable,QTd,QPagination,QDialog,QCard,QCardSection,QSeparator,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
